import React from 'react'
import { connect } from 'react-redux'
import { CircularProgress, Typography, Button, withStyles } from '@material-ui/core'
import { Image, Transformation, CloudinaryContext } from "cloudinary-react"
import uploadImagePlaceholder from '../../assets/images/upload_icon.svg'
import styles from './styles'
import { compose } from 'recompose'

class LicenseImageUpload extends React.Component {
  state = {
    selectedFile: null,
    spin: false
  }
  onDrop = file => {
    if (file && file.target && file.target.files[0]) {
      this.props.onDrop(file);
    }
  }

  render() {
    const { classes, photoID, spin, isViewProfile, showLicenseText } = this.props

    return (
      <div>
        <CloudinaryContext
          cloudName="safeshowings"
          className={classes.licenseContainer}
        >
          {!photoID && <React.Fragment>
            <p className={classes.licenseHead}>Image of Face <span className={classes.licenseNote}>(Please select license image from your local machine)</span></p>
            <div
              className={classes.customUpload}
              onClick={() => {
                document.getElementById("file-upload").click()
              }}
            >
              <img src={uploadImagePlaceholder} alt="Upload Placeholder" className={classes.uploadImagePlaceholder} width="38" />
              <Typography variant="caption" display="block" gutterBottom className={classes.uploadImageText}>
                Upload License
              </Typography>
              {spin && <CircularProgress size={24} style={{ position: 'absolute' }} />}
            </div>
          </React.Fragment>}
          {!isViewProfile && <Typography variant="h6" className={classes.profileSubHeadingInstructions}>
            Only PNG or JPEG file can be uploaded
                </Typography>}
          <input
            disabled={spin || isViewProfile}
            type="file"
            accept="image/x-png,image/jpeg"
            onChange={e => this.onDrop(e, "upload-photo-button")}
            style={{
              opacity: 0,
              padding: "10px",
              display: "none"
            }}
            id="file-upload"
          />
          {photoID && <React.Fragment>
            <Image publicId={photoID} format="png" className={classes.Image}>
              <Transformation
                crop="fill"
                gravity="faces"
                width={`${Math.round(
                  window.innerWidth - window.innerWidth * 0.1
                )}`}
                height="220"
              />
            </Image>
            {!isViewProfile && <Button
              disabled={spin || isViewProfile}
              className={classes.changeLiceneceButton}
              onClick={() => {
                document.getElementById("file-upload").click()
              }}
            >
              Change license
            {spin && <CircularProgress size={24} style={{ position: 'absolute' }} />}
            </Button>}
            {showLicenseText && <p className={classes.licenceText}>(Driving License)</p>
            }          </React.Fragment>}
        </CloudinaryContext>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser
  }
}
export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(LicenseImageUpload)

